<template>
  <modal>
    <div slot="header">
      <h3>Welcome!</h3>
    </div>
    <div slot="body">
      This is the getting started page. We recommend you go through these videos, and read the FAQ page.
    </div>
    <div slot="footer">
      <button class="btn-cta" @click="$emit('close')">Got it</button>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";

export default {
  components: {
    modal
  }
};
</script>
